import { useBreakpointValue } from '@chakra-ui/react'

export const useIsMobileAndTabletViewport = (): boolean | undefined =>
  useBreakpointValue({
    base: true,
    sm: true,
    md: false,
  })
